import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import DealModal from "./DealModal";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import QuotationForm from "../../quotation/QuotationForm";
import { Offcanvas, Dropdown } from 'react-bootstrap';
import QuotationPreviewModal from '../../quotation/QuotationPreviewModal';
import DealDetails from "./DealDetails";
import QuotationList from "../../quotation/QuotationList";
import DealList from "./DealList";
import UploadedQuotationProductsOffcanvas from "./UploadedQuotationProductsOffcanvas";
import dayjs from "dayjs";
import OrganisationDetails from "../organisation/OrganisationDetails";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Select from 'react-select';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const stages = ["suspect", "prospect", "approach", "negotiation", "closed won", "order", "closed dead", "closed lost"];
const DealsbyStage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [deals, setDeals] = useState({});
    const [searchQuery, setSearchQuery] = useState('');
    const [showDateFilters, setShowDateFilters] = useState(false);
    const [filterSettings, setFilterSettings] = useState({
        country: '',
        partner: '',
        customerType: ''
    });
    const getFinancialYear = () => {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonthNum = today.getMonth() + 1;
        try {
            const storedFormData = JSON.parse(localStorage.getItem('formData'));
            let sMonthName = storedFormData?.start_month || 'April';
            let eMonthName = storedFormData?.end_month || 'March';
            const monthMap = { January:'01', February:'02', March:'03', April:'04', May:'05', June:'06', July:'07', August:'08', September:'09', October:'10', November:'11', December:'12' };
            
            const sMonth = monthMap[sMonthName];
            const eMonth = monthMap[eMonthName] || '03';
            const sMonthInt = parseInt(sMonth);
            const eMonthInt = parseInt(eMonth);
            
            const startYear = currentMonthNum < sMonthInt ? currentYear - 1 : currentYear;
            const endYear = eMonthInt < sMonthInt ? startYear + 1 : startYear;
            const endDay = new Date(endYear, eMonthInt, 0).getDate();
            
            return { startDate: `${startYear}-${sMonth}-01`, endDate: `${endYear}-${eMonth}-${endDay}` };
        } catch (e) { return { startDate: `${currentYear}-04-01`, endDate: `${currentYear+1}-03-31` }; }
    };

    // Initialize from state or fallback to Financial Year if drilling down
    const [startDate, setStartDate] = useState(() => {
        if (location.state?.startDate) return location.state.startDate;
        if (location.state?.filterMonth) {
            const selectedMonth = dayjs(location.state.filterMonth, 'MMM YYYY');
            return selectedMonth.isValid() ? selectedMonth.startOf('month').format('YYYY-MM-DD') : '';
        }
        // If we are arriving from Dashboard but NO dates provided, use FY
        if (location.state) {
            return getFinancialYear().startDate;
        }
        return '';
    });

    const [endDate, setEndDate] = useState(() => {
        if (location.state?.endDate) return location.state.endDate;
        if (location.state?.filterMonth) {
            const selectedMonth = dayjs(location.state.filterMonth, 'MMM YYYY');
            return selectedMonth.isValid() ? selectedMonth.endOf('month').format('YYYY-MM-DD') : '';
        }
        // If we are arriving from Dashboard but NO dates provided, use FY
        if (location.state) {
            return getFinancialYear().endDate;
        }
        return '';
    });
    const [dateRangeFilter, setDateRangeFilter] = useState('yearly');
    const [countries, setCountries] = useState([]);
    const [sortBy, setSortBy] = useState('name');
    const [sortOrder, setSortOrder] = useState('asc');
    const debounceTimeoutRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedDealId, setSelectedDealId] = useState(null);
    const [selectedDealData, setSelectedDealData] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [organisations, setOrganisation] = useState([]);
    const [showQuotationModal, setShowQuotationModal] = useState(false);
    const [isOrder, setIsOrder] = useState(false); // Tracks if the quotation is for an order
    const [products, setProducts] = useState([]); // Stores products for the quotation
    const [productsFetched, setProductsFetched] = useState(false); // Ensures API call runs only if needed
    const [quotation, setQuotations] = useState([]);
    const [selectedClientId, setSelectedClientId] = useState(null);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [closedStagesExpanded, setClosedStagesExpanded] = useState(false);
    const closedStages = ["closed won", "order", "closed dead", "closed lost"];
    const [showPOAttachmentModal, setShowPOAttachmentModal] = useState(false);
    const [currentDealForPO, setCurrentDealForPO] = useState(null);
    const [poFile, setPoFile] = useState(null);
    const [poValue, setPoValue] = useState('');
    const [issueDate, setIssueDate] = useState('');
    const [poNum, setPoNum] = useState('');
    const [potot, setPotot] = useState('');

    const [showQuotationPreviewModal, setShowQuotationPreviewModal] = useState(false);
    const [selectedQuotationForPreview, setSelectedQuotationForPreview] = useState(null);
    const [brands, setBrands] = useState([]);
    const [categories, setCategories] = useState({ allSubcategories: [], allCategoriesList: [] });
    const [showLeadOffcanvas, setShowLeadOffcanvas] = useState(false);
    const handleShowLeadDetails = (dealId) => {
        setSelectedDealId(dealId);
        setShowLeadOffcanvas(true);
    };
    const handleCloseLeadDetails = () => {
        setShowLeadOffcanvas(false);
        setSelectedDealId(null);
    };
    // Add Products to Uploaded Quotations
    const [showAddProductsOffcanvas, setShowAddProductsOffcanvas] = useState(false);
    const [selectedDealForProducts, setSelectedDealForProducts] = useState(null);

    const [showOrganisationDetails, setShowOrganisationDetails] = useState(false);
    const [selectedOrganisationIdForDetails, setSelectedOrganisationIdForDetails] = useState(null);

    const handleShowOrganisationDetails = (organisationId) => {
        setSelectedOrganisationIdForDetails(organisationId);
        setShowOrganisationDetails(true);
    };

    const handleCloseOrganisationDetails = () => {
        setShowOrganisationDetails(false);
        setSelectedOrganisationIdForDetails(null);
    };
    const normalizeStage = (stage = "") => stage.toString().trim().toLowerCase();
    const showOpportunityToast = (title, icon = "success") => {
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon,
            title,
            timer: 3000,
            showConfirmButton: false,
            didOpen: () => {
                const container = Swal.getContainer();
                if (container) {
                    container.style.top = '50px';
                }
            }
        });
    };

    const handleShowAddProductsOffcanvas = (deal) => {
        setSelectedDealForProducts(deal);
        setShowAddProductsOffcanvas(true);
    };
    const handleAddProductsSuccess = () => {
        fetchDeals(); // Refresh the deals to get updated products
    };
        useEffect(() => {
        // Initial fetch only
        const finalStart = location.state?.startDate || startDate;
        const finalEnd = location.state?.endDate || endDate;
        fetchDeals(searchQuery, filterSettings, finalStart, finalEnd);
    }, []); // Run on mount

    const handleFilterSubmit = () => {
        fetchDeals(searchQuery, filterSettings, startDate, endDate);
    };

    useEffect(() => {
        fetchBrands();
        fetchCategories();
        fetchCountries();
        fetchOrganisation();
    }, []);

    useEffect(() => {
        // Handle incoming drill-down from Dashboard State
        if (location.state?.filterMonth) {
            const selectedMonth = dayjs(location.state.filterMonth, 'MMM YYYY');
            if (selectedMonth.isValid()) {
                setStartDate(selectedMonth.startOf('month').format('YYYY-MM-DD'));
                setEndDate(selectedMonth.endOf('month').format('YYYY-MM-DD'));
            }
        } else if (location.state?.startDate && location.state?.endDate) {
            setStartDate(location.state.startDate);
            setEndDate(location.state.endDate);
        } else if (location.state) {
            // Default to Financial Year if drilling down without explicit dates
            const fy = getFinancialYear();
            setStartDate(fy.startDate);
            setEndDate(fy.endDate);
        }

        // Handle incoming drill-down from Dashboard (Country)
        if (location.state?.filterCountry && countries.length > 0) {
            const country = countries.find(c => c.name === location.state.filterCountry);
            if (country) {
                setFilterSettings(prev => ({ ...prev, country: country.id }));
            }
        }
    }, [location.state, countries.length]);

    const fetchCountries = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/countries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            if (response.data && response.data.Data) {
                const sortedCountries = response.data.Data.sort((a, b) => {
                    if (a.name === 'United Arab Emirates') return -1;
                    if (b.name === 'United Arab Emirates') return 1;
                    return (a.name || '').localeCompare(b.name || '');
                });
                setCountries(sortedCountries);
            }
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const origin = localStorage.getItem('user-origin');
    const token = userInfo?.token;
    const viewCurrency = location.state?.viewCurrency || userInfo?.user?.view_currency || 'AED';
    const exchangeRate = parseFloat(localStorage.getItem('exchange_rate') || 3.672);

    const convertAmount = (amount, deal) => {
        let displayAmount = Number(amount || 0);
        const dealCurrency = (
            (deal?.transaction_type === 'partner' ? deal?.partner?.currency : null) || 
            deal?.organisation?.currency || 
            deal?.quotation?.project?.client?.currency || 
            'AED'
        ).toUpperCase();

        const viewCurr = viewCurrency.toUpperCase();

        if (viewCurr === 'USD' && dealCurrency !== 'USD') {
            displayAmount = displayAmount / exchangeRate;
        } else if (viewCurr === 'AED' && dealCurrency === 'USD') {
            displayAmount = displayAmount * exchangeRate;
        }
        return displayAmount;
    };

    const formatCurrency = (amount, deal, precision = 2) => {
        const displayAmount = convertAmount(amount, deal);
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: viewCurrency,
            minimumFractionDigits: precision,
            maximumFractionDigits: precision
        }).format(displayAmount);
    };

    const fetchDeals = async (search = '', filters = {}, fromDate = '', toDate = '') => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/deals`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: { 
                    search,
                    country: filters.country,
                    partner_id: filters.partner,
                    customer_type: filters.customerType,
                    issue_date_from: fromDate,
                    issue_date_to: toDate
                }
            });

            const groupedDeals = {};
            stages.forEach((stage) => (groupedDeals[stage] = []));
            if (response.data && response.data.data) {
                const sortedDeals = [...response.data.data].sort((a, b) => 
                    (a.name || '').localeCompare(b.name || '')
                );
                sortedDeals.forEach((deal) => {
                    const normalizedStage = normalizeStage(deal.stage);
                    const stageKey = stages.includes(normalizedStage) ? normalizedStage : "suspect";
                    groupedDeals[stageKey] = [
                        ...(groupedDeals[stageKey] || []),
                        { ...deal, stage: stageKey }
                    ];
                });
            }

            setDeals(groupedDeals);
        } catch (error) {
            console.error("Error fetching deals:", error);
        }
    };
    const fetchBrands = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/brands`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            if (response.data && response.data.brand) {
                setBrands(response.data.brand);
            }
        } catch (error) {
            console.error('Error fetching brands:', error);
        }
    };

    const handleExport = async (exportType = 'filtered') => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/deals/export`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    issue_date_from: exportType === 'all' ? '' : startDate,
                    issue_date_to: exportType === 'all' ? '' : endDate,
                    search: searchQuery,
                    country: filterSettings.country,
                    partner_id: filterSettings.partner,
                    customer_type: filterSettings.customerType,
                    view_currency: viewCurrency,
                    exchange_rate: exchangeRate
                },
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `opportunities_${dayjs().format('YYYY-MM-DD_HHmmss')}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Error exporting deals:", error);
            Swal.fire("Error", "Failed to export deals. Please try again.", "error");
        }
    };

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/categories?type=product`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            if (response.data && response.data.category) {
                const allCategories = response.data.category;
                const allCategoriesList = allCategories.filter(cat => !cat.parent_id);
                const allSubcategories = allCategories.filter(cat => cat.parent_id);
                setCategories({ allCategoriesList, allSubcategories });
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    // Handle drag start
    const handleDragStart = (e, deal) => {
        e.dataTransfer.setData("dealId", deal.id);
        e.dataTransfer.setData("fromStage", deal.stage);
    };

    // Allow dropping
    const allowDrop = (e) => {
        e.preventDefault();
    };



    const handleDragOver = (e) => {
        e.preventDefault();
        const container = document.querySelector(".row.flex-nowrap.overflow-auto");

        const maxSpeed = 50; // Maximum speed
        const edgeThreshold = 200; // Range for acceleration
        const distanceFromLeft = e.clientX;
        const distanceFromRight = window.innerWidth - e.clientX;

        let speed = 0;

        if (distanceFromLeft < edgeThreshold) {
            speed = maxSpeed * (1 - distanceFromLeft / edgeThreshold);
            container.scrollLeft -= speed;
        } else if (distanceFromRight < edgeThreshold) {
            speed = maxSpeed * (1 - distanceFromRight / edgeThreshold);
            container.scrollLeft += speed;
        }
    };


    const handleDrop = async (e, newStage) => {
        e.preventDefault();
        const dealId = e.dataTransfer.getData("dealId");
        const fromStage = e.dataTransfer.getData("fromStage");
        if (newStage === "negotiation") {
            const movedDeal = deals[fromStage].find((d) => d.id.toString() === dealId);
            if (!movedDeal.quotation_id) {
                Swal.fire({
                    icon: "warning",
                    text: "Cannot move to Negotiation stage without a quotation. Please create a quotation first.",
                    showConfirmButton: false,
                    timer: 3000,
                    position: 'top-end',
                    toast: true,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    }
                });
                return;
            }
        }
        if (fromStage === "order") {
            Swal.fire({
                icon: "warning",
                text: "Deals in 'Order' stage cannot be moved to other stages.",
                showConfirmButton: false,
                timer: 3000,
                position: 'top-end',
                toast: true,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                }
            });
            return;
        }

        if (fromStage === newStage) return;

        const movedDeal = deals[fromStage].find((d) => d.id.toString() === dealId);
        const probability = stageProbabilities[newStage] || 0;
        const expectedRevenue = movedDeal.value * (probability / 100);
        console.log("🔍 Checking deal before moving:", {
            id: movedDeal.id,
            client_id: movedDeal.client_id,
            project_id: movedDeal.project_id,
            quotation_id: movedDeal.quotation_id,
            stage: newStage,
        });
        if (newStage === "order") {
            if (!movedDeal.client_id || !movedDeal.project_id || !movedDeal.quotation_id) {
                console.warn("❌ Cannot move deal to 'Order'. Missing required fields.");

                Swal.fire({
                    icon: "warning",
                    text: "This deal cannot be moved to 'Order' because it is missing a Client, Project, or Quotation.",
                    showConfirmButton: false,
                    timer: 3000,
                    position: 'top-end',
                    toast: true,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    }


                });
                return; // Stop execution
            }

            const isQuotationUploaded = movedDeal.quotation?.is_uploaded == 1 || movedDeal.quotation?.is_uploaded === true || movedDeal.quotation?.is_uploaded === "true" || movedDeal.quotation?.is_uploaded === "1";
            
            if (!isQuotationUploaded && (!movedDeal.quotation?.product_item_details || movedDeal.quotation.product_item_details.length === 0)) {
                console.warn("❌ Cannot move deal to 'Order' without products.");
                Swal.fire({
                    icon: "warning",
                    title: "Products Required",
                    text: "Please add product details to the quotation before moving to Order stage.",
                    confirmButtonText: "Add Products Now",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                }).then((result) => {
                    if (result.isConfirmed) {
                        handleShowAddProductsOffcanvas(movedDeal);
                    }
                });
                return; // Stop execution
            }
            // Inside handleDrop function, before the try block

            // ✅ Update issales = false for client, project, and quotation
            const storedClients = JSON.parse(localStorage.getItem('clients')) || [];
            const storedProjects = JSON.parse(localStorage.getItem('projects')) || [];
            const storedQuotations = JSON.parse(localStorage.getItem('quotations')) || [];

            const updatedClients = storedClients.map(client =>
                client.id == movedDeal.client_id ? { ...client, issales: false } : client
            );

            const updatedProjects = storedProjects.map(project =>
                project.id == movedDeal.project_id ? { ...project, issales: false } : project
            );

            const updatedQuotations = storedQuotations.map(quotation =>
                quotation.id == movedDeal.quotation_id ? { ...quotation, issales: false } : quotation
            );

            localStorage.setItem('clients', JSON.stringify(updatedClients));
            localStorage.setItem('projects', JSON.stringify(updatedProjects));
            localStorage.setItem('quotations', JSON.stringify(updatedQuotations));
        }
        if (newStage === "order" || newStage === "closed dead" || newStage === "closed lost") {
            if (!movedDeal.po_attachment || !movedDeal.po_value || !movedDeal.po_number) {
                Swal.fire({
                    icon: "warning",
                    text: "This deal cannot be moved to order without PO attachment.",
                    showConfirmButton: false,
                    timer: 3000,
                    position: 'top-end',
                    toast: true,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    }
                });
                return;
            }
        }
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Send update request
            const response = await axios.put(`${backendUrl}/api/deals/${dealId}`, {
                name: movedDeal.name,
                stage: newStage,
                value: movedDeal.value,
                closed_date: movedDeal.closed_date,
                expected_revenue: expectedRevenue,
                organisation_id: movedDeal.organisation_id,
                probability: probability,
                partner_id: movedDeal.partner_id,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const updatedDealData = response.data.Data || response.data.data || {
                ...movedDeal,
                stage: newStage,
                expected_revenue: expectedRevenue,
                probability
            };
            const normalizedUpdatedDeal = {
                ...updatedDealData,
                stage: normalizeStage(updatedDealData.stage || newStage),
            };

            // Update deals state only after successful response
            setDeals((prevDeals) => {
                const newDeals = { ...prevDeals };

                // Remove deal from the old stage
                newDeals[fromStage] = newDeals[fromStage].filter((d) => d.id.toString() !== dealId);

                // Add updated deal to the new stage
                newDeals[newStage] = [...newDeals[newStage], normalizedUpdatedDeal];

                return newDeals;
            });

            await fetchDeals(searchQuery);

            // Success notification
            showOpportunityToast("Opportunity updated successfully.");

        } catch (error) {
            console.error("Error updating deal stage:", error);
            // Show error notification
            Swal.fire({
                icon: 'error',
                title: 'Update Failed',
                text: 'Could not update the opportunity. Please try again!',
            });
        }
    };


    const fetchOrganisation = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,


            });

            const data = response.data.data?.data || response.data.data || [];

            setOrganisation(data);

        } catch (error) {
            console.error(`Error fetching organisation:`, error);
        }
    };
    const addDeal = async (newDeal) => {
        try {


            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for adding
            const response = await axios.post(`${backendUrl}/api/deals`, newDeal, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const createdDeal = response.data.data || response.data.Data;

            if (createdDeal) {
                const normalizedCreatedDeal = {
                    ...createdDeal,
                    stage: normalizeStage(createdDeal.stage || newDeal.stage),
                };
                setDeals((prevDeals) => {
                    // Ensure stage exists
                    const updatedDeals = { ...prevDeals };
                    if (!updatedDeals[normalizedCreatedDeal.stage]) {
                        updatedDeals[normalizedCreatedDeal.stage] = [];
                    }
                    // Add new deal to the correct stage
                    updatedDeals[normalizedCreatedDeal.stage] = [...updatedDeals[normalizedCreatedDeal.stage], normalizedCreatedDeal];
                    return updatedDeals;
                });
            } else {
                console.error('Creation failed, no data returned.');
            }

            await fetchDeals(searchQuery);
            showOpportunityToast("Opportunity created successfully.");
            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error(`Error adding organisation`, error);
            }
        }
    };

    const editDeal = async (contactId, updatedData) => {
        try {

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for editing
            const response = await axios.put(`${backendUrl}/api/deals/${contactId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const updatedDeal = response.data.Data || response.data.data;

            if (updatedDeal) {
                const normalizedUpdatedDeal = {
                    ...updatedDeal,
                    stage: normalizeStage(updatedDeal.stage || updatedData.stage),
                };
                setDeals((prevDeals) => {
                    const updatedDeals = { ...prevDeals };
                    Object.keys(updatedDeals).forEach((stage) => {
                        updatedDeals[stage] = updatedDeals[stage].filter((deal) => deal.id !== normalizedUpdatedDeal.id);
                    });

                    if (!updatedDeals[normalizedUpdatedDeal.stage]) {
                        updatedDeals[normalizedUpdatedDeal.stage] = [];
                    }

                    updatedDeals[normalizedUpdatedDeal.stage] = [
                        ...updatedDeals[normalizedUpdatedDeal.stage],
                        normalizedUpdatedDeal
                    ];

                    Object.keys(updatedDeals).forEach((stage) => {
                        updatedDeals[stage] = updatedDeals[stage].filter(Boolean);
                    });
                    return updatedDeals;
                });

            } else {
                console.error('Update failed, no data returned.');
            }

            await fetchDeals(searchQuery);
            showOpportunityToast("Opportunity updated successfully.");
            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else
                console.error(`Error updating`, error);
        }
    };

    const deleteDeal = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Please provide a reason for deleting this opportunity:",
            input: 'textarea',
            inputPlaceholder: 'Type your reason here...',
            inputAttributes: {
                'aria-label': 'Type your reason here'
            },
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            preConfirm: (reason) => {
                if (!reason || reason.trim() === "") {
                    Swal.showValidationMessage('Deletion reason is required');
                }
                return reason;
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                const deletionReason = result.value;
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    // Send the deletion reason in the request body (or as a query param if required)
                    await axios.delete(`${backendUrl}/api/deals/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                        data: {
                            deletion_reason: deletionReason
                        }
                    });

                    const updatedDeals = { ...deals };
                    Object.keys(updatedDeals).forEach((stage) => {
                        updatedDeals[stage] = updatedDeals[stage].filter((contact) => contact.id !== id);
                    });
                    setDeals(updatedDeals);
                    await fetchDeals(searchQuery);
                    showOpportunityToast("Opportunity deleted successfully.");
                } catch (error) {
                    console.error('Error deleting opportunity:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete opportunity. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (contactId = null, stage = '') => {
        if (contactId) {
            const allDeals = Object.values(deals).flat();
            const contactToEdit = allDeals.find((contact) => contact.id === contactId);
            if (contactToEdit) {
                setSelectedDealData(contactToEdit);
            }
        } else {
            // Provide a full object with default values
            setSelectedDealData({
                name: '',
                amount: '',
                stage: stage || '', // Set the stage dynamically
                closedDate: '',
                organizationName: '',
            });
        }

        setSelectedDealId(contactId || null);
        setShowModal(true);
    };



    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedDealId(null);
        setSelectedDealData(null);
    };

    const stageColors = {
        suspect: "#EAF4FF",
        prospect: "#D6EAFF",
        approach: "#B7D9FF",
        negotiation: "#8FC2FF",
        "closed won": "#5FA6FF",
        order: "#163E8F",
        "closed dead": "#1F5FD6",
        "closed lost": "#2F7EF7",
    };

    const isStageDark = (stage) => ["closed lost", "closed dead", "order"].includes(stage);

    const stageProbabilities = {
        suspect: 10,
        prospect: 25,
        approach: 50,
        negotiation: 75,
        "closed won": 90,
        order: 100,
        "closed dead": 0,
        "closed lost": 0,
    };
    const [filteredDeals, setFilteredDeals] = useState(deals); // Store filtered deals





    const handleShowPOAttachment = (dealId) => {
        const allDeals = Object.values(deals).flat();
        const deal = allDeals.find(d => d.id === dealId);
        setCurrentDealForPO(deal);
        setPoValue(deal.po_value || '');
        setPoFile(null); // Reset file state when opening modal
        setIssueDate(deal.issue_date || '');
        setPoNum(deal.po_number || '');
        setPotot(deal.po_with_vat || '');
        setShowPOAttachmentModal(true);
    };
    const AttachmentPreview = ({
        attachmentUrl,
        file,
        onRemove,
        showOriginalName = false
    }) => {
        if (!attachmentUrl && !file) return null;

        const url = file ? URL.createObjectURL(file) : `${backendUrl}/storage/${attachmentUrl}`;
        const fileName = file ? file.name : attachmentUrl.split('/').pop();
        const fileType = file ? file.type : fileName.split('.').pop().toLowerCase();

        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(fileType);
        const isPDF = fileType === 'pdf';

        return (
            <div className="mt-3 border p-2 rounded position-relative" style={{ height: '600px', overflow: 'hidden' }}>
                {/* Close button for removing attachment */}
                {onRemove && (
                    <button
                        className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                        style={{ zIndex: 1 }}
                        onClick={onRemove}
                    >
                        <i className="mdi mdi-close"></i>
                    </button>
                )}

                {/* File preview section */}
                {isImage ? (
                    <img
                        src={url}
                        alt="PO Attachment"
                        className="img-fluid" style={{ maxHeight: '100%', objectFit: 'contain' }}
                    />
                ) : isPDF ? (
                    <iframe src={`${url}#toolbar=0&navpanes=0`} title="PO Attachment" width="100%" height="100%" frameBorder="0" />
                ) : (
                    <div className="text-center py-3">
                        <i className="mdi mdi-file-document-outline display-4 text-primary"></i>
                        <p className="mt-2 mb-1 text-truncate">
                            {showOriginalName ? fileName : 'File attached'}
                        </p>
                    </div>
                )}

                {/* Download button for existing attachments */}
                {/* {attachmentUrl && !file && (
                    <div className="mt-2 text-center">
                        <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-primary"
                            download={fileName}
                        >
                            <i className="mdi mdi-download me-1"></i> Download
                        </a>
                    </div>
                )} */}
            </div>
        );
    };
    const handleSubmitPO = async () => {
        if (!currentDealForPO || !poValue) return;

        try {
            const formData = new FormData();
            formData.append('_method', 'PUT');

            // Include required fields
            formData.append('name', currentDealForPO.name || '');
            formData.append('stage', currentDealForPO.stage || '');
            formData.append('value', currentDealForPO.value || '');
            formData.append('organisation_id', currentDealForPO.organisation_id || '');

            // Add PO-specific fields
            formData.append('po_value', poValue);
            formData.append('issue_date', issueDate);
            formData.append('po_number', poNum);
            formData.append('po_with_vat', potot);

            // Handle file attachment
            if (poFile) {
                if (poFile.size > 10 * 1024 * 1024) {
                    throw new Error("File size exceeds 10MB limit");
                }
                formData.append('po_attachment', poFile);
            } else if (!currentDealForPO.po_attachment) {
                // If removing existing attachment and not uploading new one
                formData.append('po_attachment', ''); // Send empty to clear
            }

            const response = await axios.post(
                `${backendUrl}/api/deals/${currentDealForPO.id}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            // Clean up and update state
            if (poFile) {
                URL.revokeObjectURL(poFile);
            }

            setDeals(prevDeals => {
                const newDeals = { ...prevDeals };
                newDeals[currentDealForPO.stage] = newDeals[currentDealForPO.stage].map(deal =>
                    deal.id === currentDealForPO.id
                        ? {
                            ...deal,
                            po_attachment: response.data?.deal?.po_attachment || response.data?.Data?.po_attachment || response.data?.data?.po_attachment || (poFile ? 'uploaded' : currentDealForPO.po_attachment),
                            po_value: poValue,
                            issue_date: issueDate,
                            po_number: poNum,
                            po_with_vat: potot,

                        }
                        : deal
                );
                return newDeals;
            });

            setShowPOAttachmentModal(false);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'PO details updated successfully!',
                timer: 3000,
                showConfirmButton: false,
            });
        } catch (error) {
            console.error("Error updating PO details:", error);
            Swal.fire({
                icon: 'error',
                title: 'Update Failed',
                text: error.message || error.response?.data?.message || 'Could not update PO details. Please try again!',
            });
        } finally {
            setPoFile(null);
        }
    };


    const createClient = async (dealData) => {
        try {
            if (!dealData.organisation?.country_id) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'warning',
                    text: 'Please add a country to the organisation before proceeding.',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                });
                return;
            }

            const formData = new FormData();
            formData.append("name", dealData.organisation?.name);
            formData.append("country_id", dealData.organisation?.country_id);
            formData.append("currency", dealData.organisation?.currency);
            formData.append("issales", "true");
            formData.append('short_code', dealData.organisation?.short_code || '');

            const response = await axios.post(`${backendUrl}/api/contacts?type=client`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                    'Tenant-Origin': origin,

                },
            });

            return response.data.Data;
        } catch (error) {
            console.error(`Error adding client`, error);

            let errorMessage = "Something went wrong while adding the contact. Please try again.";

            // ✅ Check for database errors
            if (error.response?.data?.message) {
                errorMessage = error.response.data.message; // Get the DB error message
            }

            // ✅ Show error message in Swal
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                text: error.response.data.error,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    // Adjust the container's position if needed
                    const container = Swal.getContainer();
                    container.style.top = '50px'; // Change this value as desired
                }
            });
        }
        //     return null;
        // }
    };

    const addProject = async (dealData, clientId) => {
        try {
            const payload = {
                name: dealData.name,
                client_id: clientId,
                issales: 'true',
            };

            const response = await axios.post(`${backendUrl}/api/projects`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            return response.data.Data;
        } catch (error) {
            console.error(" Error creating project:", error);
            return null;
        }
    };

    const [existingClients, setExistingClients] = useState([]); // Track created clients
    const [existingProjects, setExistingProjects] = useState([]); // Track created projects
    const normalizeName = (name) => name?.trim().toLowerCase();
    const [selectedQuotationId, setSelectedQuotationId] = useState(null);
    const [selectedQuotationData, setSelectedQuotationData] = useState(null);
    const handleEditQuotation = async (quotationId, dealId) => {
        try {
            setSelectedQuotationId(quotationId);
            setSelectedDealId(dealId);

            // Fetch the quotation data for editing
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            setSelectedQuotationData(response.data.quotation);
            setShowQuotationModal(true);

        } catch (error) {
            console.error("Error fetching quotation data:", error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to load quotation data',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };

    const editQuotation = async (quotationId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.post(`${backendUrl}/api/quotations/${quotationId}?_method=PUT`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const updatedQuotation = response.data.quotation;

            if (updatedQuotation) {
                // Backend versioning creates a new quotation ID and updates the deal automatically.
                // Refresh deals so the new version's ID is reflected in state.
                await fetchDeals();

                setShowQuotationModal(false);
                setSelectedQuotationId(null);
                setSelectedQuotationData(null);
                setSelectedQuotationForPreview(updatedQuotation);
                setShowQuotationPreviewModal(true);

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: `Quotation version created: ${updatedQuotation.ref_no}`,
                    timer: 3500,
                    showConfirmButton: false,
                });
            } else {
                console.error('Update failed, no data returned.');
            }
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            } else {
                console.error('Error updating quotation:', error);
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Failed to update quotation',
                    timer: 3000,
                    showConfirmButton: false,
                });
            }
        }
    };

    // ✅ NEW FUNCTION: Update deal value from quotation
    const updateDealFromQuotation = async (quotation) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Find the deal associated with this quotation
            const allDeals = Object.values(deals).flat();
            const relatedDeal = allDeals.find(deal => deal.quotation_id === quotation.id);

            if (!relatedDeal) {
                console.warn('No deal found for this quotation');
                return;
            }

            const quotationTotal = parseFloat(quotation.amount) || 0;
            const probability = stageProbabilities[relatedDeal.stage] || 0;
            const expectedRevenue = quotationTotal * (probability / 100);

            // Update the deal with new values
            await axios.put(`${backendUrl}/api/deals/${relatedDeal.id}`, {
                name: relatedDeal.name,
                stage: relatedDeal.stage,
                value: quotationTotal,
                expected_revenue: expectedRevenue,
                organisation_id: relatedDeal.organisation_id,
                probability: probability,
                partner_id: relatedDeal.partner_id,
                quotation_id: quotation.id,
                client_id: relatedDeal.client_id,
                project_id: relatedDeal.project_id
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            // Update local state
            setDeals((prevDeals) => {
                const newDeals = { ...prevDeals };
                Object.keys(newDeals).forEach((stage) => {
                    newDeals[stage] = newDeals[stage].map((deal) =>
                        deal.id === relatedDeal.id
                            ? {
                                ...deal,
                                value: quotationTotal,
                                expected_revenue: expectedRevenue
                            }
                            : deal
                    );
                });
                return newDeals;
            });

            console.log('🟢 Deal value updated from quotation');

        } catch (error) {
            console.error('❌ Error updating deal from quotation:', error);
        }
    };
    const handleCreateQuotation = async (dealId, isOrder = false) => {
        const allDeals = Object.values(deals).flat();
        const dealData = allDeals.find((deal) => deal.id === dealId);

        if (!dealData) {
            console.error("Deal not found!");
            return;
        }
        console.log("🔍 Complete deal data:", dealData);
        console.log("💰 Organisation data:", dealData.organisation);
        console.log("💵 Currency:", dealData.organisation?.currency);
        if (dealData.quotation_id) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'warning',
                title: 'Quotation has already been created!',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
            });
            return; // Exit function to prevent duplicate quotation creation
        }

        try {
            setSelectedDealId(dealId);
            setSelectedDealData(dealData);
            
            // ✅ Prioritize existing client_id from dealData
            // Do NOT fallback to organisation_id here to ensure we look for/create a proper 'client' record
            setSelectedClientId(dealData.client_id || null);
            setSelectedProjectId(dealData.project_id || null);
            
            setSelectedQuotationId(null); 
            setSelectedQuotationData(null);

            if (isOrder) {
                console.log("Order detected! Using existing products...");
                const items = Array.isArray(dealData?.product_item_details) ? dealData.product_item_details : [];

                const mappedProducts = items.map(item => ({
                    id: item.product_id,
                    product_name: item.item_name,
                    item_description: item.item_description || "",
                    price: item?.product?.selling_price || "0",
                    quantity: item.quantity || 1,
                    discount: String(item.discount || "0"),
                    subtotal: String(item.subtotal || "0"),
                }));

                console.log("Final Mapped Products:", mappedProducts);
                setIsOrder(true);
                setProductsFetched(true);
            }

            // ✅ Only open modal; client & project creation happens later
            setShowQuotationModal(true);

        } catch (error) {
            console.error("❌ Error handling quotation:", error);
        }
    };

    const addQuotation = async (newQuotation) => {
        try {
            if (!newQuotation) {
                console.error("❌ newQuotation is undefined!");
                return;
            }

            if (!newQuotation.quotation_status) {
                newQuotation.quotation_status = 'open';
            }
            newQuotation.issales = 'true';

            // ✅ Get stored clients and projects from localStorage
            const storedClients = JSON.parse(localStorage.getItem('clients')) || [];
            const storedProjects = JSON.parse(localStorage.getItem('projects')) || [];

            const allDeals = Object.values(deals).flat();
            const dealData = allDeals.find((deal) => deal.id === selectedDealId);

            if (!dealData) {
                console.error("❌ Deal not found!");
                return;
            }

            let clientId = newQuotation.client_id || dealData.client_id;
            let projectId = newQuotation.project_id || dealData.project_id;

            // ✅ Check if client already exists (type: client)
            if (!clientId) {
                const existingClient = storedClients.find(client =>
                    normalizeName(client.name) === normalizeName(dealData.organisation?.name) &&
                    client.contact_type === 'client'
                );

                if (existingClient) {
                    console.log("✔ Found existing 'client' in localStorage:", existingClient.name);
                    clientId = existingClient.id;
                } else {
                    console.log("🔹 Creating New Client (type: client)...");
                    const newClient = await createClient(dealData);
                    if (!newClient) {
                        console.error("❌ Failed to create client.");
                        return;
                    }
                    clientId = newClient.id;

                    const updatedClients = [...storedClients, {
                        id: clientId,
                        name: dealData.organisation?.name,
                        country_id: dealData?.organisation?.country_id,
                        currency: dealData?.organisation?.currency,
                        issales: 'true',
                        short_code: dealData.organisation?.short_code || '',
                        created_by: dealData.organisation?.created_by || '',
                    }];
                    localStorage.setItem('clients', JSON.stringify(updatedClients));
                }
            }

            // ✅ Check if project already exists (prioritize existing IDs)
            if (!projectId) {
                const existingProject = storedProjects.find(project =>
                    normalizeName(project.name) === normalizeName(dealData.name) && project.client_id === clientId
                );

                if (existingProject) {
                    console.log("✔ Found existing project in localStorage:", existingProject.name);
                    projectId = existingProject.id;
                } else {
                    console.log("🔹 Creating New Project...");
                    const newProject = await addProject(dealData, clientId);
                    if (!newProject) {
                        console.error("❌ Failed to create project.");
                        return;
                    }
                    projectId = newProject.id;

                    // ✅ Save new project to localStorage
                    const updatedProjects = [...storedProjects, {
                        id: projectId,
                        name: dealData.name,
                        client_id: clientId,
                        issales: 'true',
                        created_by: dealData?.created_by || '',
                    }];
                    localStorage.setItem('projects', JSON.stringify(updatedProjects));
                }
            }

            newQuotation.client_id = clientId;
            newQuotation.project_id = projectId;

            const formData = new FormData();
            Object.keys(newQuotation).forEach(key => {
                if (key !== "products") {
                    formData.append(key, newQuotation[key]);
                }
            });

            formData.append('issales', 'true');

            const response = await axios.post(`${backendUrl}/api/quotations`, newQuotation, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                    'Tenant-Origin': origin,
                },
            });

            const createdQuotation = response.data.quotation;
            const quotationId = createdQuotation.id;
            const quotationTotal = parseFloat(newQuotation.amount) || parseFloat(newQuotation.amount);
            const probability = stageProbabilities[dealData.stage] || 0;
            const expectedRevenue = quotationTotal * (probability / 100);
            try {

                const updateDealResponse = await axios.put(`${backendUrl}/api/deals/${dealData.id}`, {
                    name: dealData.name,
                    quotation_id: String(quotationId),
                    client_id: String(clientId),
                    project_id: String(projectId),
                    value: quotationTotal,
                    expected_revenue: expectedRevenue

                }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                console.log("🟢 Deal update response:", updateDealResponse.data);
                setSelectedDealData(prevDeal => {
                    console.log("🟢 Updating state with new quotation ID:", createdQuotation.id);
                    return {
                        ...prevDeal,
                        client_id: clientId,
                        project_id: projectId,
                        quotation_id: createdQuotation.id,
                        value: quotationTotal,
                        expected_revenue: expectedRevenue,
                    };
                });

                // Dynamically update the specific deal in the 'deals' state so UI changes immediately
                setDeals(prevDeals => {
                    const newDeals = { ...prevDeals };
                    for (const stage in newDeals) {
                        const dealIndex = newDeals[stage].findIndex(d => d.id === dealData.id);
                        if (dealIndex !== -1) {
                            newDeals[stage][dealIndex] = {
                                ...newDeals[stage][dealIndex],
                                quotation_id: createdQuotation.id,
                                client_id: clientId,
                                project_id: projectId,
                                value: quotationTotal,
                                expected_revenue: expectedRevenue
                            };
                            break;
                        }
                    }
                    return newDeals;
                });
                fetchDeals();

            } catch (error) {
                console.error("❌ API Update Error:", error.response ? error.response.data : error);
            }




            setQuotations((prevQuotations) => [...prevQuotations, createdQuotation]);

            setSelectedQuotationForPreview(createdQuotation);
            setShowQuotationPreviewModal(true);
            setShowQuotationModal(false);
            // Swal.fire({
            //     toast: true,
            //     position: 'top-end',
            //     icon: 'success',
            //     title: 'Quotation Created Successfully!',
            //     timer: 3000,
            //     timerProgressBar: false,
            //     showConfirmButton: false,
            //     didOpen: () => {
            //         const container = Swal.getContainer();
            //         container.style.top = '50px';
            //     },
            // });

        } catch (error) {
            console.error("❌ Error adding quotation:", error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to create quotation',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };

    const handleShowQuotationPreview = async (quotationId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            let quotationToShow = response.data.quotation;
            if (response.data.versions && response.data.versions.length > 0) {
                quotationToShow = response.data.versions.reduce((latest, current) => {
                    return (current.version > latest.version) ? current : latest;
                }, response.data.versions[0]);
            }

            setSelectedQuotationForPreview(quotationToShow);
            setShowQuotationPreviewModal(true);
        } catch (error) {
            console.error("Error fetching quotation for preview:", error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to load quotation preview',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };

    // NEW: Handle Download PDF
    const handleDownloadPDF = async (quotationId, refNo) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotations/${quotationId}/download`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Quotation_${refNo}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading PDF:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to download PDF',
                timer: 3000,
                showConfirmButton: false,
            });
        }
    };

    // NEW: Handle Edit from Preview
    const handleEditFromPreview = (quotationId, dealId) => {
        setShowQuotationPreviewModal(false);
        handleEditQuotation(quotationId, dealId);
    };
    const [viewType, setViewType] = useState('grid');
    const deploymentDescriptions = selectedQuotationForPreview?.editable_deployment_descriptions
        ? typeof selectedQuotationForPreview.editable_deployment_descriptions === 'string'
            ? JSON.parse(selectedQuotationForPreview.editable_deployment_descriptions)
            : selectedQuotationForPreview.editable_deployment_descriptions
        : {};



    const shouldShowDeal = (deal) => {
        // If deal is in "order" stage and is_direct_order is true, hide it
        if (deal.stage === "order" && deal.is_direct_order === true) {
            return false;
        }
        return true;
    };

    // Add this state variable near your other useState declarations
    const [showQuotationUploadOffcanvas, setShowQuotationUploadOffcanvas] = useState(false);
    const [selectedDealForUpload, setSelectedDealForUpload] = useState(null);
    const [uploadFormData, setUploadFormData] = useState({
        client_name: '',
        project_name: '',
        ref_no: '',
        subscription_amount: '',
        deployment_amount: '',
        total_amount: '',
        quotation_date: new Date().toISOString().split('T')[0],
        license_type_id: '',
        model_type: '', // 'new' or 'expand'
        quotation_file: null
    });

    // Add this function to handle opening the upload offcanvas (for new uploads)
    const handleQuotationUpload = (deal) => {
        setSelectedDealForUpload(deal);
        setUploadFormData({
            client_name: deal.organisation?.name || '',
            project_name: deal.name || '',
            ref_no: '',
            subscription_amount: '',
            deployment_amount: '',
            total_amount: '',
            quotation_date: new Date().toISOString().split('T')[0],
            license_type_id: '',
            model_type: '',
            quotation_file: null,
            isEditing: false,
            editingQuotationId: null,
        });
        setShowQuotationUploadOffcanvas(true);
    };

    // Handle editing an uploaded quotation — prefill form with existing data
    const handleEditUploadedQuotation = async (deal) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/quotations/${deal.quotation_id}`, {
                headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin },
                skipLoader: true,
            });
            const q = response.data.quotation;

            setSelectedDealForUpload(deal);
            setUploadFormData({
                client_name: deal.organisation?.name || '',
                project_name: deal.name || '',
                ref_no: q.ref_no || '',
                subscription_amount: q.total_amount_with_subscription || q.subscription_amount || '',
                deployment_amount: q.deplyment_amount || '',
                total_amount: q.amount || '',
                quotation_date: q.date || new Date().toISOString().split('T')[0],
                license_type_id: q.license_type_id || '',
                model_type: q.model_type || '',
                quotation_file: null, // User must re-upload if they want a new file
                isEditing: true,
                editingQuotationId: q.id,
            });
            setShowQuotationUploadOffcanvas(true);
        } catch (error) {
            console.error('Error loading uploaded quotation for edit:', error);
            Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'Failed to load quotation', timer: 3000, showConfirmButton: false });
        }
    };

    const handleUploadInputChange = (e) => {
        const { name, value, files } = e.target;

        if (name === 'quotation_file') {
            setUploadFormData(prev => ({
                ...prev,
                [name]: files[0]
            }));
        } else {
            setUploadFormData(prev => {
                const newState = {
                    ...prev,
                    [name]: value
                };

                // Auto-calculate total if subscription or deployment amount is changed
                if (name === 'subscription_amount' || name === 'deployment_amount') {
                    const sub = parseFloat(name === 'subscription_amount' ? value : prev.subscription_amount) || 0;
                    const dep = parseFloat(name === 'deployment_amount' ? value : prev.deployment_amount) || 0;
                    newState.total_amount = (sub + dep).toString();
                }

                return newState;
            });
        }
    };

    const handleQuotationUploadSubmit = async () => {
        const isEditing = uploadFormData.isEditing;


        if (!uploadFormData.ref_no) {
            Swal.fire({ toast: true, position: 'top-end', icon: 'warning', title: 'Please enter quotation reference number', timer: 3000, showConfirmButton: false });
            return;
        }



        try {
            // ── EDIT PATH: version the existing uploaded quotation ─────────
            if (isEditing && uploadFormData.editingQuotationId) {
                const formData = new FormData();
                formData.append('ref_no', uploadFormData.ref_no);
                formData.append('amount', uploadFormData.total_amount);
                formData.append('date', uploadFormData.quotation_date);
                formData.append('total_amount_with_subscription', uploadFormData.subscription_amount || 0);
                formData.append('deplyment_amount', uploadFormData.deployment_amount || 0);
                formData.append('license_type_id', uploadFormData.license_type_id);
                formData.append('model_type', uploadFormData.model_type || '');
                formData.append('issales', 'true');
                formData.append('is_uploaded', 'true');
                if (uploadFormData.quotation_file) {
                    formData.append('quotation_file', uploadFormData.quotation_file);
                }
                // No products for uploaded quotations edited via this form
                formData.append('_method', 'PUT');

                const response = await axios.post(
                    `${backendUrl}/api/quotations/${uploadFormData.editingQuotationId}?_method=PUT`,
                    formData,
                    { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data', 'Tenant-Origin': origin } }
                );

                await fetchDeals();
                setShowQuotationUploadOffcanvas(false);
                Swal.fire({
                    toast: true, position: 'top-end', icon: 'success',
                    title: `New version created: ${response.data.quotation?.ref_no}`,
                    timer: 3500, showConfirmButton: false,
                });
                return;
            }

            // ── CREATE PATH: new uploaded quotation ───────────────────────
            const storedClients = JSON.parse(localStorage.getItem('clients')) || [];
            let clientId = null;

            const existingClient = storedClients.find(client =>
                normalizeName(client.name) === normalizeName(selectedDealForUpload.organisation?.name) &&
                client.contact_type === 'client'
            );

            if (existingClient) {
                clientId = existingClient.id;
            } else {
                const newClient = await createClient(selectedDealForUpload);
                if (newClient) { clientId = newClient.id; } else { throw new Error('Failed to create client'); }
            }

            const storedProjects = JSON.parse(localStorage.getItem('projects')) || [];
            let projectId = null;

            const existingProject = storedProjects.find(project =>
                project.name === selectedDealForUpload.name && project.client_id === clientId
            );

            if (existingProject) {
                projectId = existingProject.id;
            } else {
                const newProject = await addProject(selectedDealForUpload, clientId);
                if (newProject) { projectId = newProject.id; } else { throw new Error('Failed to create project'); }
            }

            const formData = new FormData();
            formData.append('client_id', clientId);
            formData.append('project_id', projectId);
            formData.append('ref_no', uploadFormData.ref_no);
            formData.append('amount', uploadFormData.total_amount);
            formData.append('date', uploadFormData.quotation_date);
            formData.append('total_amount_with_subscription', uploadFormData.subscription_amount || 0);
            formData.append('deplyment_amount', uploadFormData.deployment_amount || 0);
            formData.append('license_type_id', uploadFormData.license_type_id);
            formData.append('model_type', uploadFormData.model_type);
            formData.append('quotation_status', 'open');
            formData.append('issales', 'true');
            formData.append('is_uploaded', true);
            formData.append('products[0]', '');
            formData.append('quotation_file', uploadFormData.quotation_file);

            const response = await axios.post(`${backendUrl}/api/quotations`, formData, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'multipart/form-data', 'Tenant-Origin': origin },
            });

            const createdQuotation = response.data.quotation;

            await axios.put(`${backendUrl}/api/deals/${selectedDealForUpload.id}`, {
                name: selectedDealForUpload.name,
                quotation_id: String(createdQuotation.id),
                client_id: String(clientId),
                project_id: String(projectId),
                value: uploadFormData.total_amount,
                expected_revenue: uploadFormData.total_amount * (stageProbabilities[selectedDealForUpload.stage] / 100),
                one_time_cost: uploadFormData.deployment_amount || 0,
                recurring_cost: uploadFormData.subscription_amount || 0,
            }, { headers: { Authorization: `Bearer ${token}`, 'Tenant-Origin': origin } });

            // Dynamically update the specific deal in the 'deals' state so UI changes immediately
            setDeals(prevDeals => {
                const newDeals = { ...prevDeals };
                for (const stage in newDeals) {
                    const dealIndex = newDeals[stage].findIndex(d => d.id === selectedDealForUpload.id);
                    if (dealIndex !== -1) {
                        newDeals[stage][dealIndex] = {
                            ...newDeals[stage][dealIndex],
                            quotation_id: createdQuotation.id,
                            client_id: clientId,
                            project_id: projectId
                        };
                        break;
                    }
                }
                return newDeals;
            });

            await fetchDeals();
            setShowQuotationUploadOffcanvas(false);
            Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Quotation uploaded successfully!', timer: 3000, showConfirmButton: false });

        } catch (error) {
            console.error("Error uploading quotation:", error);
            let errorMessage = 'Failed to upload quotation';
            if (error.response?.data?.errors) { errorMessage = Object.values(error.response.data.errors).flat().join(', '); }
            else if (error.response?.data?.message) { errorMessage = error.response.data.message; }
            else if (error.message) { errorMessage = error.message; }
            Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: errorMessage, timer: 5000, showConfirmButton: false });
        }
    };

    return (
        <>
            {viewType === 'grid' ? (
                <>
                    <div className="main-content">
                        <div className="page-content">
                            <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex flex-wrap align-items-center justify-content-between">
                                        <h4 className="mb-sm-0 font-size-18">Deals by Stage</h4>

                                        <div className="d-flex flex-wrap align-items-center gap-3 ms-auto justify-content-end">
                                            {/* Search Box */}
                                            <div className="search-box">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search"
                                                        value={searchQuery}
                                                        onChange={(e) => setSearchQuery(e.target.value)}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-center gap-2">
                                                {showDateFilters && (
                                                    <div className="d-flex align-items-center gap-2 animate__animated animate__fadeInRight">
                                                          <div className="d-flex align-items-center gap-1">
                                                              <span className="small text-muted fw-semibold me-1">From:</span>
                                                              <ReactDatePicker
                                                                  selected={startDate ? new Date(startDate) : null}
                                                                  onChange={(date) => setStartDate(date ? dayjs(date).format('YYYY-MM-DD') : '')}
                                                                  className="form-control form-control-sm"
                                                                  dateFormat="dd/MM/yyyy"
                                                                  placeholderText="Select Date"
                                                                  style={{ fontSize: '12px', padding: '4px 8px', width: '110px' }}
                                                              />
                                                          </div>
                                                          <div className="d-flex align-items-center gap-1">
                                                              <span className="small text-muted fw-semibold me-1">To:</span>
                                                              <ReactDatePicker
                                                                  selected={endDate ? new Date(endDate) : null}
                                                                  onChange={(date) => setEndDate(date ? dayjs(date).format('YYYY-MM-DD') : '')}
                                                                  className="form-control form-control-sm"
                                                                  dateFormat="dd/MM/yyyy"
                                                                  placeholderText="Select Date"
                                                                  style={{ fontSize: '12px', padding: '4px 8px', width: '110px' }}
                                                              />
                                                          </div>
                                                          <button 
                                                              className="btn btn-sm btn-success px-3"
                                                              onClick={handleFilterSubmit}
                                                              title="Submit Filters"
                                                          >
                                                              Submit
                                                          </button>
                                                          <button 
                                                              className="btn btn-sm btn-primary px-3"
                                                              onClick={() => handleExport('filtered')}
                                                            title="Apply and Download"
                                                        >
                                                            Apply
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm btn-outline-danger border-0 p-1"
                                                            onClick={() => {
                                                                setShowDateFilters(false);
                                                                setStartDate('');
                                                                setEndDate('');
                                                            }}
                                                            title="Clear Date Filter"
                                                        >
                                                            <i className="mdi mdi-close-circle h5 mb-0"></i>
                                                        </button>
                                                    </div>
                                                )}

                                                <Dropdown>
                                                    <Dropdown.Toggle
                                                        variant="light"
                                                        className="btn btn-light border no-caret"
                                                        id="dropdown-export"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Export Options"
                                                    >
                                                        <i className="mdi mdi-file-excel text-success"></i>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu align="end" className="shadow-sm border-0">
                                                        <Dropdown.Item onClick={() => {
                                                            setShowDateFilters(false);
                                                            setStartDate('');
                                                            setEndDate('');
                                                            handleExport('all');
                                                        }}>
                                                            <i className="mdi mdi-all-inclusive me-2 text-primary"></i>
                                                            Export All
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => {
                                                            setShowDateFilters(!showDateFilters);
                                                            if (!showDateFilters) {
                                                                setStartDate('');
                                                                setEndDate('');
                                                            }
                                                        }}>
                                                            <i className="mdi mdi-calendar-range me-2 text-info"></i>
                                                            Export by Date Range
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>

                                            {/* View Type Toggle (Single Icon) */}
                                            <div className="nav-item">
                                                <button
                                                    className="btn btn-outline-primary bg-soft border-0"
                                                    onClick={() => setViewType(viewType === 'grid' ? 'list' : 'grid')}
                                                    title={viewType === 'grid' ? 'Switch to List View' : 'Switch to Tile View'}
                                                >
                                                    <i className={`mdi h4 mb-0 ${viewType === 'grid' ? 'mdi-format-list-bulleted' : 'mdi-view-grid-outline'}`} />
                                                </button>
                                            </div>

                                            {/* Filter Tab */}
                                            <div className="dropdown">
                                                <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside">
                                                    <i className="mdi mdi-filter-variant me-1"></i> Filter
                                                </button>
                                                <div className="dropdown-menu dropdown-menu-end p-3 shadow-lg" style={{ minWidth: '350px', borderRadius: '15px' }}>
                                                    <h6 className="dropdown-header px-0 mb-3 text-primary fw-bold">Advanced Filters</h6>
                                                    
                                                    <div className="mb-3">
                                                          <label className="form-label small fw-bold text-muted d-block mb-1">Start Date</label>
                                                          <ReactDatePicker
                                                              selected={startDate ? new Date(startDate) : null}
                                                              onChange={(date) => setStartDate(date ? dayjs(date).format('YYYY-MM-DD') : '')}
                                                              className="form-control form-control-sm w-100"
                                                              wrapperClassName="w-100"
                                                              dateFormat="dd/MM/yyyy"
                                                              showMonthDropdown
                                                              showYearDropdown
                                                              dropdownMode="select"
                                                              placeholderText="Select Start Date"
                                                              style={{ fontSize: '12px', borderRadius: '8px', padding: '6px 10px' }}
                                                          />
                                                      </div>

                                                    <div className="mb-3">
                                                          <label className="form-label small fw-bold text-muted d-block mb-1">End Date</label>
                                                          <ReactDatePicker
                                                              selected={endDate ? new Date(endDate) : null}
                                                              onChange={(date) => setEndDate(date ? dayjs(date).format('YYYY-MM-DD') : '')}
                                                              className="form-control form-control-sm w-100"
                                                              wrapperClassName="w-100"
                                                              dateFormat="dd/MM/yyyy"
                                                              showMonthDropdown
                                                              showYearDropdown
                                                              dropdownMode="select"
                                                              placeholderText="Select End Date"
                                                              style={{ fontSize: '12px', borderRadius: '8px', padding: '6px 10px' }}
                                                          />
                                                      </div>

                                                    <div className="mb-3">
                                                        <label className="form-label small fw-bold text-muted">Country</label>
                                                        <Select
                                                            options={countries.map(c => ({ value: c.id, label: c.name }))}
                                                            value={countries.map(c => ({ value: c.id, label: c.name })).find(opt => opt.value == filterSettings.country) || null}
                                                            onChange={(opt) => setFilterSettings({ ...filterSettings, country: opt ? opt.value : '' })}
                                                            placeholder="Select Country..."
                                                            isClearable
                                                            isSearchable
                                                            styles={{
                                                                control: (base) => ({ ...base, fontSize: '12px', borderRadius: '8px' }),
                                                                menu: (base) => ({ ...base, fontSize: '12px', zIndex: 9999 })
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label small fw-bold text-muted">Partner</label>
                                                        <Select
                                                            options={organisations.filter(org => org.org_type === 'partner').map(p => ({ value: p.id, label: p.name }))}
                                                            value={organisations.filter(org => org.org_type === 'partner').map(p => ({ value: p.id, label: p.name })).find(opt => opt.value === filterSettings.partner) || null}
                                                            onChange={(opt) => setFilterSettings({ ...filterSettings, partner: opt ? opt.value : '' })}
                                                            placeholder="Select Partner..."
                                                            isClearable
                                                            isSearchable
                                                            styles={{
                                                                control: (base) => ({ ...base, fontSize: '12px', borderRadius: '8px' }),
                                                                menu: (base) => ({ ...base, fontSize: '12px', zIndex: 9999 })
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="mb-0">
                                                        <label className="form-label small fw-bold text-muted">Customer Type</label>
                                                        <Select
                                                            options={[
                                                                { value: 'new customer', label: 'New Customer' },
                                                                { value: 'existing customer', label: 'Existing Customer' }
                                                            ]}
                                                            value={[
                                                                { value: 'new customer', label: 'New Customer' },
                                                                { value: 'existing customer', label: 'Existing Customer' }
                                                            ].find(opt => opt.value === filterSettings.customerType) || null}
                                                            onChange={(opt) => setFilterSettings({ ...filterSettings, customerType: opt ? opt.value : '' })}
                                                            placeholder="Select Type..."
                                                            isClearable
                                                            styles={{
                                                                control: (base) => ({ ...base, fontSize: '12px', borderRadius: '8px' }),
                                                                menu: (base) => ({ ...base, fontSize: '12px', zIndex: 9999 })
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="mt-3 border-top pt-2 d-flex justify-content-between align-items-center">
                                                          <span className="small text-muted">{(Object.values(filterSettings).filter(Boolean).length + (startDate ? 1 : 0) + (endDate ? 1 : 0))} filters applied</span>
                                                          <div className="d-flex gap-3 align-items-center">
                                                              <button className="btn btn-sm btn-link text-danger p-0 text-decoration-none" onClick={() => {
                                                                  setFilterSettings({ country: '', partner: '', customerType: '' });
                                                                  setStartDate('');
                                                                  setEndDate('');
                                                                  setDateRangeFilter('yearly');
                                                                  if (location.state) { navigate(location.pathname, { replace: true, state: {} }); }
                                                                  // also call fetchDeals with empty
                                                                  fetchDeals(searchQuery, { country: '', partner: '', customerType: '' }, '', '');
                                                              }}>Clear All</button>
                                                              <button className="btn btn-sm btn-primary px-3 rounded shadow-sm" onClick={handleFilterSubmit}>Submit</button>
                                                          </div>
                                                      </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                </div>
                            </div>


                            <div className="row flex-nowrap overflow-auto" style={{ whiteSpace: "nowrap" }} onDragOver={handleDragOver}>

                                {stages.map((stage) => {
                                    // if (closedStages.includes(stage) && !closedStagesExpanded) return null;

                                    let rawDeals = filteredDeals[stage] || deals[stage] || [];
                                    
                                    // If drill-down filter is active, only show deals for the matching stage, but keep all headers
                                    if (location.state?.filterStage && stage !== location.state.filterStage.toLowerCase()) {
                                        rawDeals = [];
                                    }

                                    const stageDeals = [...rawDeals].sort((a, b) => {
                                        let valA, valB;
                                        if (sortBy === 'closed_date') {
                                            valA = new Date(a.closed_date || 0);
                                            valB = new Date(b.closed_date || 0);
                                        } else if (sortBy === 'value') {
                                            valA = Number(a.value || 0);
                                            valB = Number(b.value || 0);
                                        } else {
                                            valA = (a.name || '').toLowerCase();
                                            valB = (b.name || '').toLowerCase();
                                        }

                                        if (valA < valB) return sortOrder === 'asc' ? -1 : 1;
                                        if (valA > valB) return sortOrder === 'asc' ? 1 : -1;
                                        return 0;
                                    });

                                    const stageTotalValue = stageDeals?.reduce((total, deal) => { 
                                        if (!shouldShowDeal(deal)) return total;
                                        return total + convertAmount(deal.value, deal); 
                                    }, 0) || 0; 
                                    const stageWeightedAverage = stageDeals?.reduce((total, deal) => { 
                                        if (!shouldShowDeal(deal)) return total;
                                        return total + convertAmount(deal.expected_revenue, deal); 
                                    }, 0) || 0;

                                    return (
                                        <React.Fragment key={stage}>

                                            <div style={{ width: "290px", position: 'relative' }}>
                                                <div className="card border-0 shadow-sm" style={{ 
                                                    background: `linear-gradient(180deg, ${stageColors[stage]}20 0%, #f9fafb 100%)`,
                                                    borderRadius: '16px'
                                                }}>

                                                    <div className="card-header5 py-3 px-3" style={{ 
                                                        background: `linear-gradient(135deg, ${stageColors[stage]} 0%, rgba(0,0,0,0.08) 100%)`,
                                                        color: isStageDark(stage) ? '#ffffff' : '#334155',
                                                        borderBottom: '1px solid rgba(0,0,0,0.05)'
                                                    }}>

                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <h6 className="mb-0 text-capitalize">
                                                                  {stage} ({stageProbabilities[stage]}%) <span className="badge rounded-pill ms-2 shadow-sm" style={{ backgroundColor: isStageDark(stage) ? 'rgba(255, 255, 255, 0.25)' : 'rgba(0, 0, 0, 0.08)', color: isStageDark(stage) ? '#ffffff' : '#1e293b', fontSize: '0.75rem', backdropFilter: 'blur(4px)', border: isStageDark(stage) ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)' }}>{stageDeals?.filter(d => shouldShowDeal(d)).length || 0}</span>
                                                              </h6>
                                                            <div className="d-flex align-items-center ms-auto">
                                                                <div className="dropdown me-1">
                                                                    <button className="btn btn-sm p-0 no-arrow" type="button" data-bs-toggle="dropdown" data-bs-boundary="viewport">
                                                                        <i className={`mdi mdi-sort-variant ${isStageDark(stage) ? 'text-white' : 'text-muted'}`} style={{ fontSize: '1.1rem' }}></i>
                                                                    </button>
                                                                    <ul className="dropdown-menu dropdown-menu-end">
                                                                        <li><h6 className="dropdown-header">Sort By</h6></li>
                                                                        <li><a className="dropdown-item d-flex justify-content-between align-items-center" href="#" onClick={(e) => { e.preventDefault(); setSortBy('closed_date'); setSortOrder(sortBy === 'closed_date' && sortOrder === 'asc' ? 'desc' : 'asc'); }}>
                                                                            Close Date {sortBy === 'closed_date' && <i className={`mdi mdi-arrow-${sortOrder === 'asc' ? 'up' : 'down'}`}></i>}
                                                                        </a></li>
                                                                        <li><a className="dropdown-item d-flex justify-content-between align-items-center" href="#" onClick={(e) => { e.preventDefault(); setSortBy('value'); setSortOrder(sortBy === 'value' && sortOrder === 'asc' ? 'desc' : 'asc'); }}>
                                                                            Deal Value {sortBy === 'value' && <i className={`mdi mdi-arrow-${sortOrder === 'asc' ? 'up' : 'down'}`}></i>}
                                                                        </a></li>
                                                                        <li><a className="dropdown-item d-flex justify-content-between align-items-center" href="#" onClick={(e) => { e.preventDefault(); setSortBy('name'); setSortOrder(sortBy === 'name' && sortOrder === 'asc' ? 'desc' : 'asc'); }}>
                                                                            Name {sortBy === 'name' && <i className={`mdi mdi-arrow-${sortOrder === 'asc' ? 'up' : 'down'}`}></i>}
                                                                        </a></li>
                                                                    </ul>
                                                                </div>
                                                                <button className="btn btn-sm rounded-circle" onClick={() => handleShowModal(null, stage)}>
                                                                    <i className={`mdi mdi-plus ${isStageDark(stage) ? 'text-white' : 'text-dark'}`}></i>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <div className={`mt-2 ${isStageDark(stage) ? 'text-white' : 'text-dark'}`}>
                                                            <div className="font-size-13 fw-bold">
                                                                Total: {new Intl.NumberFormat('en-US', { style: 'currency', currency: viewCurrency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(stageTotalValue)}
                                                            </div>
                                                            <div className="font-size-12 opacity-75">
                                                                Weighted Average: {new Intl.NumberFormat('en-US', { style: 'currency', currency: viewCurrency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(stageWeightedAverage)}
                                                            </div></div>
                                                    </div>
                                                    <div className="card-body task-list" onDragOver={allowDrop} onDrop={(e) => handleDrop(e, stage)} >
                                                        {stageDeals?.length > 0 ? (
                                                            stageDeals.map((deal) => (
                                                                shouldShowDeal(deal) && (
                                                                    <div key={deal.id} className="deal-card mb-3 rounded-4" draggable onDragStart={(e) => handleDragStart(e, deal)}>
                                                                        <div className="card-body p-3 deal-card-inner position-relative">
                                                                            <div className="dropdown float-end d-flex align-items-center">
                                                                                {(deal.quotation?.is_uploaded == 1 || deal.quotation?.is_uploaded === true || deal.quotation?.is_uploaded === "true" || deal.is_uploaded === "true") && (
                                                                                    <i className="mdi mdi-paperclip text-success me-2" title="Quotation Uploaded" style={{ fontSize: '14px' }}></i>
                                                                                )}
                                                                                <i className="mdi mdi-dots-horizontal text-muted h5 mb-0" data-bs-toggle="dropdown" data-bs-boundary="viewport" style={{ cursor: 'pointer' }}></i>
                                                                                <div className="dropdown-menu dropdown-menu-end font-size-14">
                                                                                    <a className="dropdown-item" href="#" onClick={() => handleShowModal(deal.id)}>Edit</a>
                                                                                    <a className="dropdown-item" href="#" onClick={() => deleteDeal(deal.id)}>Delete</a>
                                                                                    {deal.quotation_id ? (
                                                                                        <>
                                                                                            {(deal.quotation?.is_uploaded == 1 || deal.quotation?.is_uploaded === true || deal.quotation?.is_uploaded === "true" || deal.is_uploaded === "true") ? (
                                                                                                <>
                                                                                                    <a
                                                                                                        className="dropdown-item"
                                                                                                        href="#"
                                                                                                        onClick={(e) => {
                                                                                                            e.preventDefault();
                                                                                                            handleShowQuotationPreview(deal.quotation_id);
                                                                                                        }}
                                                                                                    >
                                                                                                        View Quotation
                                                                                                    </a>
                                                                                                    {(deal.stage === "negotiation" || deal.stage === "approach") && (
                                                                                                        <a
                                                                                                            className="dropdown-item"
                                                                                                            href="#"
                                                                                                            onClick={(e) => {
                                                                                                                e.preventDefault();
                                                                                                                handleEditUploadedQuotation(deal);
                                                                                                            }}
                                                                                                        >
                                                                                                            Edit Quotation
                                                                                                        </a>
                                                                                                    )}
                                                                                                    {(deal.stage === "closed won" || deal.stage === "order") && (
                                                                                                        <a
                                                                                                            className="dropdown-item"
                                                                                                            href="#"
                                                                                                            onClick={(e) => {
                                                                                                                e.preventDefault();
                                                                                                                handleShowAddProductsOffcanvas(deal);
                                                                                                            }}
                                                                                                        >
                                                                                                            {deal.quotation?.product_item_details?.length > 0 ? "View Product Details" : "Add Products & Details"}
                                                                                                        </a>
                                                                                                    )}
                                                                                                </>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <a
                                                                                                        className="dropdown-item"
                                                                                                        href="#"
                                                                                                        onClick={() => handleShowQuotationPreview(deal.quotation_id)}
                                                                                                    >
                                                                                                        View Quotation
                                                                                                    </a>
                                                                                                    <a
                                                                                                        className="dropdown-item"
                                                                                                        href="#"
                                                                                                        onClick={() => handleEditQuotation(deal.quotation_id, deal.id)}
                                                                                                    >
                                                                                                        Edit Quotation
                                                                                                    </a>
                                                                                                </>
                                                                                            )}
                                                                                        </>
                                                                                    ) : (
                                                                                        deal.stage !== "suspect" && deal.stage !== "prospect" && deal.stage !== "order" && (
                                                                                            <a
                                                                                                className="dropdown-item"
                                                                                                href="#"
                                                                                                onClick={(e) => {
                                                                                                    e.preventDefault();
                                                                                                    Swal.fire({
                                                                                                        title: 'Add Quotation',
                                                                                                        text: 'How would you like to add a quotation?',
                                                                                                        icon: 'question',
                                                                                                        showCancelButton: true,
                                                                                                        showDenyButton: true,
                                                                                                        confirmButtonText: 'Generate Quotation',
                                                                                                        denyButtonText: 'Upload Quotation',
                                                                                                        cancelButtonText: 'Cancel'
                                                                                                    }).then((result) => {
                                                                                                        if (result.isConfirmed) {
                                                                                                            handleCreateQuotation(deal.id, true);
                                                                                                        } else if (result.isDenied) {
                                                                                                            handleQuotationUpload(deal);
                                                                                                        }
                                                                                                    });
                                                                                                }}
                                                                                            >
                                                                                                Generate or Upload Quotation
                                                                                            </a>
                                                                                        )
                                                                                    )}
                                                                                    {(deal.stage === "closed won" || deal.stage === "order" || deal.stage === "closed lost" || deal.stage === "closed dead") && (
                                                                                        <a
                                                                                            className="dropdown-item"
                                                                                            href="#"
                                                                                            onClick={() => handleShowPOAttachment(deal.id)}
                                                                                        >
                                                                                            {deal.po_attachment ? "PO Details" : "Add PO"}
                                                                                        </a>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className="deal-card-meta mb-3">
                                                                                <h5 className="deal-card-title mb-2" title={deal.name}>
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => handleShowLeadDetails(deal.id)}
                                                                                        className="btn btn-link p-0 text-start deal-title-link"
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            whiteSpace: 'nowrap',
                                                                                            overflow: 'hidden',
                                                                                            textOverflow: 'ellipsis',
                                                                                            textDecoration: 'none',
                                                                                            fontSize: '13px',
                                                                                            fontWeight: 600,
                                                                                            color: '#334155'
                                                                                        }}
                                                                                    >
                                                                                        {deal.name?.length > 24 ? `${deal.name.slice(0, 24)}...` : deal.name}
                                                                                    </button>
                                                                                </h5>
                                                                                <div className="deal-meta-info">
                                                                                    {/* Removed stage badge */}
                                                                                    <span 
                                                                                        className="deal-org-text" 
                                                                                        title={deal.organisation?.name || 'No organisation'}
                                                                                        onClick={() => deal.organisation?.id && handleShowOrganisationDetails(deal.organisation.id)}
                                                                                        style={{ cursor: 'pointer', color: '#2F7EF7', fontSize: '15px', fontWeight: '600' }}
                                                                                    >
                                                                                        {deal.organisation?.name 
                                                                                            ? (deal.organisation.name.length > 15 
                                                                                                ? `${deal.organisation.name.slice(0, 15)}...` 
                                                                                                : deal.organisation.name)
                                                                                            : 'No organisation'}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <p className={new Date(deal.closed_date) < new Date() ? "text-danger mb-0" : "text-dark mb-0"} style={{ fontSize: '13px' }}>
                                                                                    {deal.closed_date}
                                                                                </p>
                                                                                <h5 className="deal-card-value mb-0">
                                                                                    {formatCurrency(deal.value, deal)}
                                                                                </h5>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            ))
                                                        ) : (
                                                            <div className="text-center text-muted">
                                                                No deals found
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {closedStages.includes(stage) && !closedStagesExpanded ? null : null}
                                        </React.Fragment>
                                    );
                                })}

                            </div>

                            <Offcanvas
                                show={showPOAttachmentModal}
                                onHide={() => setShowPOAttachmentModal(false)}
                                placement="end"
                                backdrop={true}
                                scroll={false}
                                style={{ width: '480px' }}
                            >
                                <Offcanvas.Header closeButton>
                                    <Offcanvas.Title>
                                        {currentDealForPO?.po_attachment ? "PO Details" : "Add PO Details"}
                                    </Offcanvas.Title>
                                </Offcanvas.Header>
                                <hr style={{ margin: 0 }} />
                                <Offcanvas.Body>


                                    {currentDealForPO?.po_attachment && !poFile && (
                                        <div className="mb-3">
                                            <label className="form-label form-font">PO Attachment</label>
                                            <AttachmentPreview
                                                attachmentUrl={currentDealForPO.po_attachment}
                                                showOriginalName={true}
                                                onRemove={null}  // disable the X button
                                            />
                                        </div>
                                    )}


                                    {!poFile && !currentDealForPO?.po_attachment && (
                                        <div className="mb-3">
                                            <label className="form-label form-font">PO Attachment</label>
                                            <input
                                                type="file"
                                                className="form-control form-feild"
                                                onChange={(e) => setPoFile(e.target.files[0])}
                                                name="po_attachment"
                                                accept="*"
                                                id="poAttachmentInput"
                                            />
                                        </div>
                                    )}

                                    {poFile && (
                                        <div className="mb-3">
                                            <label className="form-label">PO Attachment</label>
                                            <AttachmentPreview
                                                file={poFile}
                                                showOriginalName={true}
                                                onRemove={() => {
                                                    setPoFile(null);
                                                    document.getElementById('poAttachmentInput').value = '';
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div className="mb-3">
                                        <label className="form-label form-font">PO Amount</label>
                                        <input
                                            type="number"
                                            className="form-control form-feild"
                                            value={poValue}
                                            onChange={(e) => setPoValue(e.target.value)}
                                            name="po_value"
                                        />
                                    </div><br />
                                    <div className="mb-3">
                                        <label className="form-label form-font">Issued Date</label>
                                        <input
                                            type="date"
                                            className="form-control form-feild"
                                            value={issueDate}
                                            onChange={(e) => setIssueDate(e.target.value)}
                                            name="issue_date"
                                        />
                                    </div><br />
                                    <div className="mb-3">
                                        <label className="form-label form-font">PO Number</label>
                                        <input
                                            type="text"
                                            className="form-control form-feild"
                                            value={poNum}
                                            onChange={(e) => setPoNum(e.target.value)}
                                            name="po_number"
                                        />
                                    </div><br />
                                    <div className="mb-3">
                                        <label className="form-label form-font">PO Amount With VAT</label>
                                        <input
                                            type="text"
                                            className="form-control form-feild"
                                            value={potot}
                                            onChange={(e) => setPotot(e.target.value)}
                                            name="po_with_vat"
                                        />
                                    </div><br />
                                </Offcanvas.Body>

                                <div className="p-3 d-flex justify-content-end border-top">

                                    <button
                                        type="button"
                                        className="btn btn-secondary me-2"
                                        onClick={() => setShowPOAttachmentModal(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleSubmitPO}
                                    >
                                        {currentDealForPO?.po_attachment ? "Update" : "Save"}
                                    </button>
                                </div>
                            </Offcanvas>
                            {/* Quotation Upload Offcanvas */}
                            <Offcanvas
                                show={showQuotationUploadOffcanvas}
                                onHide={() => setShowQuotationUploadOffcanvas(false)}
                                placement="end"
                                backdrop={true}
                                scroll={false}
                                style={{ width: '580px' }}
                            >
                                <Offcanvas.Header closeButton>
                                    <Offcanvas.Title>{uploadFormData.isEditing ? 'Edit Quotation' : 'Add Quotation'}</Offcanvas.Title>
                                </Offcanvas.Header>
                                <hr style={{ margin: 0 }} />
                                <Offcanvas.Body>
                                    {/* Client Name (Read-only) */}
                                    <div className="mb-3">
                                        <label className="form-label form-font">Client Name</label>
                                        <input
                                            type="text"
                                            className="form-control form-feild"
                                            name="client_name"
                                            value={uploadFormData.client_name}
                                            readOnly
                                            disabled
                                        />
                                    </div>

                                    {/* Project Name (Read-only) */}
                                    <div className="mb-3">
                                        <label className="form-label form-font">Project Name</label>
                                        <input
                                            type="text"
                                            className="form-control form-feild"
                                            name="project_name"
                                            value={uploadFormData.project_name}
                                            readOnly
                                            disabled
                                        />
                                    </div>

                                    {/* Quotation Date */}
                                    <div className="mb-3">
                                        <label className="form-label form-font">Quotation Date</label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                value={uploadFormData.quotation_date ? dayjs(uploadFormData.quotation_date) : null}
                                                onChange={(newValue) => {
                                                    handleUploadInputChange({
                                                        target: {
                                                            name: 'quotation_date',
                                                            value: newValue ? newValue.format('YYYY-MM-DD') : ''
                                                        }
                                                    });
                                                }}
                                                format="DD/MM/YYYY"
                                                slotProps={{
                                                    textField: {
                                                        size: 'small',
                                                        fullWidth: true,
                                                        className: 'form-feild',
                                                        sx: {
                                                            '& .MuiInputBase-root': {
                                                                fontSize: '13px',
                                                                backgroundColor: '#fff',
                                                                borderRadius: '14px',
                                                                border: '0.5px solid rgb(232, 233, 237)',
                                                                padding: '0px',
                                                                height: '39px',
                                                            },
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                border: 'none',
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '13px',
                                                                padding: '8px 12px',
                                                            },
                                                        }
                                                    },
                                                    popper: {
                                                        style: { zIndex: 99999 },
                                                        placement: 'bottom-start',
                                                    },
                                                    desktopPaper: {
                                                        style: { zIndex: 99999 },
                                                    },
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>

                                    {/* Reference Number */}
                                    <div className="mb-3">
                                        <label className="form-label form-font">Reference No <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control form-feild"
                                            name="ref_no"
                                            value={uploadFormData.ref_no}
                                            onChange={handleUploadInputChange}
                                            placeholder="Enter reference number"
                                            required
                                        />
                                    </div>
                                    {/* License Type Dropdown - Using existing categories.subcategories */}
                                    <div className="mb-3">
                                        <label className="form-label form-font">License Type <span className="text-danger">*</span></label>
                                        <select
                                            className="form-select form-feild"
                                            name="license_type_id"
                                            value={uploadFormData.license_type_id}
                                            onChange={handleUploadInputChange}
                                            required
                                        >
                                            <option value="">Select License Type</option>
                                            {categories.allCategoriesList?.sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(type => (
                                                <option key={type.id} value={type.id}>
                                                    {type.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>



                                    {/* Subscription Amount */}
                                    <div className="mb-3">
                                        <label className="form-label form-font">Subscription Amount</label>
                                        <input
                                            type="number"
                                            className="form-control form-feild"
                                            name="subscription_amount"
                                            value={uploadFormData.subscription_amount}
                                            onChange={handleUploadInputChange}
                                        />
                                    </div>

                                    {/* Deployment Amount */}
                                    <div className="mb-3">
                                        <label className="form-label form-font">Deployment Amount</label>
                                        <input
                                            type="number"
                                            className="form-control form-feild"
                                            name="deployment_amount"
                                            value={uploadFormData.deployment_amount}
                                            onChange={handleUploadInputChange}
                                        />
                                    </div>

                                    {/* Total Amount (Editable, auto-calculated from Sub + Dep) */}
                                    <div className="mb-3">
                                        <label className="form-label form-font">Total Amount</label>
                                        <input
                                            type="number"
                                            className="form-control form-feild"
                                            name="total_amount"
                                            value={uploadFormData.total_amount}
                                            onChange={handleUploadInputChange}

                                        />
                                    </div>



                                    {/* File Upload */}
                                    <div className="mb-3">
                                        <label className="form-label form-font">Quotation File <span className="text-danger">*</span></label>
                                        <input
                                            type="file"
                                            className="form-control form-feild"
                                            name="quotation_file"
                                            onChange={handleUploadInputChange}
                                            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                                            required
                                        />
                                        <small className="text-muted">Supported formats: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG</small>
                                    </div>

                                    {/* File name display if file selected */}
                                    {uploadFormData.quotation_file && (
                                        <div className="alert alert-info py-2">
                                            <i className="mdi mdi-file-document-outline me-2"></i>
                                            {uploadFormData.quotation_file.name}
                                        </div>
                                    )}
                                </Offcanvas.Body>

                                <div className="p-3 d-flex justify-content-end border-top">
                                    <button
                                        type="button"
                                        className="btn btn-secondary me-2"
                                        onClick={() => setShowQuotationUploadOffcanvas(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleQuotationUploadSubmit}
                                    >
                                        Save
                                    </button>
                                </div>
                            </Offcanvas>

                    <DealModal
                        showModal={showModal}
                        handleClose={handleCloseModal}
                        dealId={selectedDealId}
                        dealData={selectedDealData}
                        addDeal={addDeal}
                        editDeal={editDeal}
                        deals={deals}
                        fetchOrganisation={fetchOrganisation}
                        organisations={organisations}
                        setOrganisation={setOrganisation}
                    />
                    {showQuotationModal &&
                        <QuotationForm
                            showModal={showQuotationModal}
                            handleClose={() => {
                                setShowQuotationModal(false);
                                setSelectedQuotationId(null);
                                setSelectedQuotationData(null); // Reset quotation data when closing
                            }}
                            quotationId={selectedQuotationId}
                            quotationData={selectedQuotationData}
                            projectId={selectedProjectId} // Correct Project ID
                            defaultClientId={selectedClientId}
                            // projectName={selectedDealData?.name || selectedQuotationData?.project?.name}
                            // clientName={selectedDealData?.organisation?.name || selectedQuotationData?.project?.client?.name}
                            // clientCurrency={selectedDealData?.organisation?.currency || selectedQuotationData?.project?.client?.currency}
                            projectName={
                                selectedQuotationId
                                    ? selectedQuotationData?.project?.name
                                    : selectedDealData?.name || "Project Name"
                            }
                            clientName={
                                selectedQuotationId
                                    ? selectedQuotationData?.project?.client?.name
                                    : selectedDealData?.organisation?.name || "Client Name"
                            }
                            clientCurrency={
                                selectedQuotationId
                                    ? selectedQuotationData?.project?.client?.currency
                                    : selectedDealData?.organisation?.currency || "AED"
                            }

                            isOrder={isOrder}  // <-- NEW: Pass isOrder flag
                            products={products}
                            addQuotation={addQuotation}
                            setProducts={setProducts}
                            dealData={selectedDealData}
                            editQuotation={editQuotation}
                        // defaultClientId={selectedDealData?.organisation_id}
                        />}


                    {showQuotationPreviewModal && selectedQuotationForPreview && (
                        <QuotationPreviewModal
                            showModal={showQuotationPreviewModal}
                            handleClose={() => {
                                setShowQuotationPreviewModal(false);
                                setSelectedQuotationForPreview(null);
                            }}
                            onEdit={() => {
                                const allDeals = Object.values(deals).flat();
                                const relatedDeal = allDeals.find(deal =>
                                    deal.quotation_id === selectedQuotationForPreview.id
                                );
                                if (relatedDeal) {
                                    handleEditFromPreview(selectedQuotationForPreview.id, relatedDeal.id);
                                }
                            }}
                            onDownload={() => handleDownloadPDF(
                                selectedQuotationForPreview.id,
                                selectedQuotationForPreview.ref_no
                            )}
                            clientName={selectedQuotationForPreview.project?.client?.name || "Client Name"}
                            projectName={selectedQuotationForPreview.project?.name || "Project Name"}
                            clientCurrency={selectedQuotationForPreview.project?.client?.currency || "AED"}
                            brands={brands}
                            categories={categories}
                            selectedProducts={selectedQuotationForPreview?.product_item_details || []}
                            customIntegrationDescription={selectedQuotationForPreview.custom_integration_description || ""}
                            customIntegrationTotal={selectedQuotationForPreview.custom_integration_total || 0}
                            formData={selectedQuotationForPreview}
                            editableDeploymentDescriptions={deploymentDescriptions || ''}
                            isUploaded={selectedQuotationForPreview.is_uploaded === true || selectedQuotationForPreview.is_uploaded === 1 || selectedQuotationForPreview.is_uploaded === '1'}
                            uploadedFileUrl={selectedQuotationForPreview.quotation_file}
                        />
                    )}
                    <DealDetails
                        show={showLeadOffcanvas}
                        onHide={handleCloseLeadDetails}
                        dealId={selectedDealId}
                    // onOrganisationUpdate={fetchOrganisation} // Pass refresh function if needed
                    />

                    <UploadedQuotationProductsOffcanvas
                        show={showAddProductsOffcanvas}
                        handleClose={() => {
                            setShowAddProductsOffcanvas(false);
                            setSelectedDealForProducts(null);
                        }}
                        deal={selectedDealForProducts}
                        onSuccess={handleAddProductsSuccess}
                    />

                    {showOrganisationDetails && (
                        <OrganisationDetails
                            showOffcanvas={showOrganisationDetails}
                            handleClose={handleCloseOrganisationDetails}
                            organisationId={selectedOrganisationIdForDetails}
                            onOrganisationUpdate={fetchDeals}
                        />
                    )}

                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <DealList />
            )}
        </>
    );


}
export default DealsbyStage;



